var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"pa-0"},[_c('mobiledisplay',{staticClass:"hidden-md-and-up"}),_c('mediumdisplay',{staticClass:"hidden-sm-and-down"}),_c('v-content',{staticClass:"pa-0"},[_c('router-view',{staticClass:"pa-0"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }